import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable */
import React from 'react';
import { JourneysSelectors, useAppSelector } from 'conversional-journey';
import { createComponentsFromObject } from 'conversional-components';
var PRELOADER_CONTENT = {
    Content: {
        type: 'Flexbox',
        format: 'component',
    },
    Children: {},
};
var Preloader = function () {
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    return (_jsx(_Fragment, { children: createComponentsFromObject({
            root: PRELOADER_CONTENT,
        }) }));
};
export default Preloader;
